module.exports = __webpack_public_path__ + "static/media/view student talent.175f7a5d.svg";